import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { reportError } from 'shared/services/raygunService';
import { LoaderContext } from '../../../shared/context/loaderContext';
import { NotificationContext } from '../../../shared/context/notificationContext';
import { useCm360Api } from '../../../shared/const/api-backend';
import { getToken } from '../../../shared/const/token.helper';
import { getBrandFromModifiedBooking } from '../../../shared/helpers/policyModification.helper';
import useFetchPayments from './paymentTab/useFetchPayments';

const paymentPendingStatuses = ['authorized', 'submitted_for_settlement'];

const useModifyPolicy = () => {
  const { setLoading } = useContext(LoaderContext);
  const { showNotification } = useContext(NotificationContext);
  const { fetchPayments } = useFetchPayments();
  const API = useCm360Api();
  const navigate = useNavigate();

  const modifyPolicy = async (policy) => {
    const policyId = policy.policy.policyNumber;
    setLoading(true);
    let result;

    const payments = await fetchPayments(policy.bookingDataId);

    if (payments.some((p) => paymentPendingStatuses.includes(p.status))) {
      showNotification('COMMON.error.modificationPendingPayment', 'error');
      return;
    }

    try {
      const apiUrl = `/booking/from-policy`;
      const body = {
        policyId,
      };
      const { data } = await API.post(apiUrl, body);
      result = true;
      const token = getToken();
      const selectedBrand = getBrandFromModifiedBooking(data);

      const redirectUrl = `/quote?brand=${selectedBrand}&bookingDataId=${data.bookingData.id}&agent=true&token=${token}`;
      navigate(redirectUrl);
    } catch (error) {
      showNotification('Error creating new version of policy', 'error');
      reportError(error);
    } finally {
      setLoading(false);
      return result;
    }
  };

  return { modifyPolicy };
};

export default useModifyPolicy;
